// extracted by mini-css-extract-plugin
export var actionButton = "_dp-0";
export var attachmentLine = "_dp-1";
export var fileInput = "_dp-2";
export var fileUploadWrapper = "_dp-4";
export var footer = "_dp-3";
export var modalContent = "_dp-5";
export var paperclip = "_dp-6";
export var quillEditor = "_dp-7";